import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from "@/views/Login";
import CommonLayout from "@/views/CommonLayout";
import EstateCompanyIndex from '@/views/estate-company/Index'
import EstateCompanyLayout from '@/views/estate-company/EstateComLayout'
import FuncLayout from "@/views/func/FuncLayout";
import FuncList from "@/views/func/FuncList";
import AppFuncList from "@/views/func/AppFuncList";
import CommonSettingLayout from "@/views/common-setting/CommonSettingLayout";
import Dictionary from "@/views/common-setting/Dictionary";
import DocTpl from "@/views/common-setting/DocTpl";
import SettingItem from "@/views/common-setting/SettingItem";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '超管后台-登录',
    },
    component: Login
  },
  {
    path: '/',
    name: 'CommonLayout',
    component: CommonLayout,
    children: [
        //首页
      {
        path: '/',
        name: 'Home',
        meta: {
          title: '超管后台-首页',
        },
        component: Home
      },
        //物业公司
      {
        path: 'estate-company',
        component: EstateCompanyLayout,
        children: [
          {
            path: 'index',
            name: 'EstateCompanyIndex',
            meta: {
              title: '超管后台-公司列表',
            },
            component: EstateCompanyIndex
          },
          {
            path: '/',
            redirect: 'index'
          }
        ],
        meta: {
          requireAuth: true,  // 进入这个路由是需要登录的
        },
      },
        //功能管理
      {
        path: 'func',
        component: FuncLayout,
        children: [
          {
            path: 'list',
            name: 'FuncList',
            meta: {
              title: '超管后台-功能列表',
            },
            component: FuncList
          },{
            path: 'AppFuncList',
            name: 'AppFuncList',
            meta: {
              title: '超管后台-app功能列表',
            },
            component: AppFuncList
          }

        ],
        meta: {
          requireAuth: true,  // 进入这个路由是需要登录的
      },
      },
        //公共配置
      {
        path: 'common-setting',
        component: CommonSettingLayout,
        children: [
          {
            path: 'dictionary',
            name: 'Dictionary',
            meta: {
              title: '超管后台-字典管理',
            },
            component: Dictionary
          },
          {
            path: 'docTpl',
            name: 'DocTpl',
            meta: {
              title: '超管后台-文档模板',
            },
            component: DocTpl
          },
          {
            path: 'settingItem',
            name: 'SettingItem',
            meta: {
              title: '超管后台-首选设置项',
            },
            component: SettingItem
          }
        ],
        meta: {
          requireAuth: true,  // 进入这个路由是需要登录的
      },
      }
    ],
    meta: {
      requireAuth: true,  // 进入这个路由是需要登录的
  },
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next)=>{
  if (to.meta.title) {
    window.document.title = to.meta.title;
  }
  if (to.path === '/login'){
    next();
  }else{
    if (!JSON.parse(sessionStorage.getItem('is_login'))) {
      router.push('/login');
  } else {
      next();
  }


    // let cookies = document.cookie.split(";");
    // let token = localStorage.getItem('Authorization');
    // if (token === null || token === '') {
    //   // next('/login');
    //   router.push('/login')
    // } else {
    //   next();
    // }
    // let logged = false;
    // for (let cookie of cookies) {
    //   let cookiePair = cookie.split("=",2);
    //   let key = cookiePair[0].trim();
    //   if (key === "root-admin-session-id"){
    //     logged = true;
    //     break;
    //   }
    // }
    // if (logged){
    //   next();
    // }else{
    //   next("/login")
    // }

}
});

export default router
